import { useEffect, useState } from "react"
import Cookies from 'js-cookie';
// import NotificationBell from './NotificationBell';
import HeaderCart from './HeaderCart';
import HeaderAccount from './HeaderAccount';
import LanuageBtn from '../../buttons/LanguageBtn';
import { WhatsAppLinkSmall } from "../../../features/contactUs/components/WhatsAppLink";

export default function Account() {
    const [isLogIn, setIsLogIn] = useState(false);

    useEffect(() => {
        if (Cookies.get('token')) {
            setIsLogIn(true)
        }
    }, [isLogIn]);

    return (
        <div className="user-icon d-flex flex-nowrap justify-content-center dropdown pt-2 pt-sm-0 align-items-start">
            {/* <NotificationBell /> */}
            <HeaderCart />
            <HeaderAccount />
            <LanuageBtn />
            <WhatsAppLinkSmall />
        </div>


    )
};



